<template>
    <div>
        <router-link :to="{ name: 'projekt-management', hash: '#methodik' }">
            <article class="message" :class="{ 'transition-up move-up-on-hover': !this.isMobile && !this.isTablet }">
                <div class="message-header message-header-color-4 is-size-5-custom message-header-center has-text-centered" :class="{ 'min-text-height-message': !this.isTablet, 'min-text-height-message-custom-tablet': this.isTablet }">
                    <p>{{ $t('kmso.project_management.main_box_4_title') }}</p>
                </div>
                <div class="message-body is-size-5-custom">
                    <figure class="image is-3by2">
                        <img src="/img/projektmanagement8.svg" :alt="$t('kmso.project_management.main_box_4_title')">
                    </figure>
                </div>
                <div class="message-footer message-header-color-4 is-size-5-custom">
                    <div class="is-vertical-center add-horizontal-center message-min-text-footer-height">
                        <p class="link-text">
                            {{ $t('kmso.general.learn_more') }}
                        </p>
                    </div>
                </div>
            </article>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: 'Projektmanagement-4',
        props: [
            'isMobile',
            'isTablet',
        ],
    }
</script>
